import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";

import Header from "./component/Header/Header";
import Footer from "./component/Footer/Footer";

import Home from "./Pages/HomePage/HomePage";
import ContactUs from "./Pages/ContactUs/ContactUs";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Signup from "./Pages/Signup/Signup";
import Login from "./Pages/Signup/Login";
import CityPage from "./Pages/Cities/cities";
import PlacePage from "./Pages/Places/places";
import PlacesPage from "./Pages/PlacesPage/PlacesPage";
import CategoryPage from "./Pages/category/Category";
import AllDestinations from "./Pages/AllDestinations/AllDestinations";
import Mapus from "./Pages/Mapus/Mapus";

import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { CategoryProvider } from "./context/CategoryContext";
import CountryPerContinetPage from "./Pages/Continet_Contries/CountryPerContinetPage";
import PlaceDetailsPage from "./Pages/PalceDetails/placeDetails";
import PostAd from "./Pages/PostAds/PostAd";
import AdDetails from "./Pages/Ads/AdDetails";
import AdsPage from "./Pages/Ads/AdsPage";

// ✅ SCROLL BUTTON
import ScrollToTopButton from "./component/ScrollToTopButton/ScrollToTopButton";
import ScrollToTopOnNavigate from "./component/ScrollToTop/ScrollToTop";

const App = () => {
  const { t } = useTranslation();
 useEffect(() => {
  console.log("useEffect running");
  console.log("API URL:", process.env.REACT_APP_API_URL);
  if (!sessionStorage.getItem("siteVisitLogged")) {
    axios.post(`${process.env.REACT_APP_API_URL}/api/site/visit`, {})
      .then(() => {
        sessionStorage.setItem("siteVisitLogged", "true");
        console.log("Visit logged");
      })
      .catch((err) => {
        console.error("Visit log error", err);
      });
  }
}, []);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const theme = createTheme({
    typography: {
      fontFamily:
        "var(--font-sans), system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
  });

  const MainContent = () => {
    const location = useLocation();
    const hideFooterPaths = ["/signup", "/login"];
    const shouldHideFooter = hideFooterPaths.includes(location.pathname);

    return (
      <>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/all-destinations" element={<AllDestinations t={t} />} />
          <Route path="/home" element={<Home t={t} />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/categories" element={<AllDestinations t={t} />} />
          <Route path="/countries" element={<CountryPerContinetPage t={t} />} />
          <Route path="/cities/:countryId" element={<CityPage t={t} />} />
          <Route path="/places" element={<PlacePage t={t} />} />
          <Route path="/cityplaces/:cityId" element={<PlacesPage />} />
          <Route path="/map" element={<Mapus t={t} />} />
          <Route path="/category/:categoryId" element={<CategoryPage t={t} />} />
          <Route path="/place-details/:placeID" element={<PlaceDetailsPage />} />
          <Route path="/post" element={<PostAd />} />
          <Route path="/ads/:id" element={<AdDetails t={t} />} />
          <Route path="/ads" element={<AdsPage />} />
        </Routes>

        {!shouldHideFooter && <Footer t={t} changeLanguage={changeLanguage} />}
      </>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <CategoryProvider>
        <div className="App">
    <ScrollToTopOnNavigate />
          {/* ✅ ALWAYS VISIBLE ON ALL PAGES */}
          <ScrollToTopButton />

          <MainContent />
        </div>
      </CategoryProvider>
    </ThemeProvider>
  );
};

export default App;
